module.exports = __webpack_public_path__ + "static/img/img_book.0c657e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_book.jpg
// module id = bUaw
// module chunks = 0